<template>
  <div class="custom-section-box">
    <div class="ant-advanced-search-form item">
      <div style="margin-bottom: 14px;">
        <a-radio-group v-model="currentWebSiteType" @change="handleWebSiteTypeChange">
          <a-radio-button value="Signet">Signet</a-radio-button>
          <a-radio-button value="Supera">Supera</a-radio-button>
        </a-radio-group>
      </div>
      <div class="coupon-statistics" v-if="statisticalData && statisticalData.length > 0">
        <span class="stat-label">Total Coupons:</span> 
        <span class="stat-value">{{ statisticalData[0] }}</span>
        
        <span class="stat-label">Available:</span> 
        <span class="stat-value">{{ statisticalData[1] }}</span>
        
        <span class="stat-label">Used:</span> 
        <span class="stat-value">{{ statisticalData[2] }}</span>
        
        <span class="stat-label">Expired:</span> 
        <span class="stat-value">{{ statisticalData[3] }}</span>
      </div>
      <s-table
        :style="!isShowEdit ? { display: 'table' } : { overflow: 'auto' }"
        ref="table"
        rowKey="id"
        showQuickJumper
        :columns="!isShowEdit ? columns : mainColumns"
        :data="loadData"
        :rowSelection="rowSelectionConfig"
      >
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="couponCode" slot-scope="text, record">
          <a v-if="isCouponClickable(record)" @click="handleCouponCodeClick(record)">{{ record.couponCode }}</a>
          <span v-else>{{ record.couponCode }}</span>
        </span>
        <span slot="description" slot-scope="text, record">
          <div :title="record.description" style="max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ record.description }}</div>
        </span>
        <span slot="amount" slot-scope="text, record">
          <div v-if="record.bkrfr" style="white-space: nowrap;">
            <span v-if="record.bkrfr == 'sigusa' || record.bkrfr == 'supusa'">USD {{ record.amount }}</span>
            <span v-if="record.bkrfr == 'sigcan' || record.bkrfr == 'supcan'">CAD {{ record.cAmount }}</span>
          </div>
          <div v-else style="white-space: nowrap;">
            <div v-if="record.amount">USD {{ record.amount }}</div>
            <div v-if="record.cAmount">CAD {{ record.cAmount }}</div>
          </div>
        </span>
        <!-- <span slot="startDate" slot-scope="text">{{ dateFormatB(text) }}</span> -->
        <!-- 优惠券状态 0 未使用 1 已使用 -->
        <span slot="couponStatus" slot-scope="text, record">
          <a-tag 
            v-if="text === '0'" 
            :color="record.expirationDate && new Date(record.expirationDate) < new Date() ? '#DC3545' : '#198754'"
          >
            {{ text === '0' && record.expirationDate && new Date(record.expirationDate) < new Date() ? 'Expired' : 'Available' }}
          </a-tag>
          <a-tag v-else :color="record.transferToCustomerCode && record.transferToCustomerCode.length > 0 ? '#faad14' : '#6C757D'">
            {{ (record.transferToCustomerCode && record.transferToCustomerCode.length > 0) ? 'Transferred' : 'Used' }}
          </a-tag>
        </span>
      </s-table>
    </div>
    <a-modal
      v-if="editData"
      :dialog-style="{ top: '120px' }"
      :visible="isModalShow"
      :maskClosable="false"
      :destroyOnClose="true"
      title="Manage Coupon"
      okText="Save"
      cancelText="Cancel"
      @cancel="() => { this.isModalShow = false }"
      @ok="handleSave"
      :okButtonProps="{ props:{ loading: saving } }"
    >
      <div class="coupon-info-container">
        <div class="coupon-info-row">
          <div class="coupon-info-item">
            <span class="info-label">Code:</span> 
            <span class="info-content">{{ editData.couponCode }}</span>
          </div>
          <div class="coupon-info-item">
            <span class="info-label">Description:</span> 
            <span class="info-content">{{ editData.description }}</span>
          </div>
        </div>
        <div class="coupon-info-row">
          <div class="coupon-info-item">
            <span class="info-label">Amount:</span> 
            <span class="info-content">
              <span v-if="editData.amount" style="margin-right: 10px;">USD{{ editData.amount }}</span>
              <span v-if="editData.cAmount">CAD{{ editData.cAmount }}</span>
            </span>
          </div>
          <div class="coupon-info-item">
            <span class="info-label">Exp.Date:</span> 
            <span class="info-content">{{ editData.expirationDate ? dateFormatB(editData.expirationDate) : 'No' }}</span>
          </div>
          <div class="coupon-info-item">
            <span class="info-label">Status:</span> 
            <span class="info-content">
              <span v-if="editData.couponStatus === '0'">Available</span>
              <span v-else>
                {{ (editData.transferToCustomerCode && editData.transferToCustomerCode.length > 0) ? 'Transferred' : 'Used' }}
              </span>
            </span>
          </div>
          <div class="coupon-info-item">
            <span class="info-label">Transferable:</span> 
            <span class="info-content">{{ editData.transferable == '1' ? 'Yes' : 'No' }}</span>
          </div>
        </div>
      </div>
      <a-form-model
        :model="convertForm"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="Customer ID"
              :validateStatus="toCustomerCodeValid.status"
              :help="toCustomerCodeValid.help"
            >
              <a-input v-model="convertForm.toCustomerCode" placeholder="Please input customer code" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="Remark">
              <a-textarea v-model="convertForm.remark" auto-size placeholder="Please input remark" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { toSTablePage } from '@/utils/util'
import STable from '@/components/table/'
import CustomerCouponApi from '@/api/api-cdb-customer-coupon'
import CustomerApi from '@/api/api-cdb-custome-v2'
import moment from 'moment'

export default {
  name: 'CdbCustomerCoupon',
  components: {
    STable
  },
  props: {
    record: {
      type: [Object],
      default: null,
    },
    isShowEdit: {
      type: Boolean,
      default: false
    },
    isMainShow: {
      type: Boolean,
      default: true
    },
    webSiteType: {
      type: String,
      default: 'Signet'
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      // 加载中
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      // queryParam: { customerId: this.customerId },
      // 表头
      columns :[
      {
        title: '#',
        align:'center',
        scopedSlots: { customRender: 'serial' }
      },
      {
        title: 'Code',
        dataIndex: 'couponCode',
        scopedSlots: { customRender: 'couponCode' }
      },
      {
        title: 'Description',
        dataIndex: 'description',
        scopedSlots: { customRender: 'description' }
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        scopedSlots: { customRender: 'amount' }
      },
      {
        title: 'Exp.Date',
        dataIndex: 'expirationDate',
        customRender: (text) => {
          if(text && text != null){
            return moment(text).format('MM/DD/YYYY')
          }
          return 'No'
        }
      },
      {
        title: 'Date Used',
        dataIndex: 'bkUseTime',
        customRender: (text) => {
        if(text && text != null){
          return moment(text).format('MM/DD/YYYY')
          }
          return 'No'
        }
      },
      {
        title: 'Bkg# Used',
        dataIndex: 'bkrId',
        customRender: (value) => value ? value : ''
      },
      {
        title: 'Transferable',
        dataIndex: 'transferable',
        customRender: (value) => value == '1' ? 'Yes' : 'No'
      },
      {
        title: 'Combine',
        dataIndex: 'combine',
        customRender: (value) => value == '1' ? 'Yes' : 'No'
      },
      {
        title: 'Status',
        dataIndex: 'couponStatus',
        // customRender: (value) => value == '0' ? 'Not Use' : 'Used'
        scopedSlots: { customRender: 'couponStatus' }
      },
    ],
    mainColumns: [
      {
        title: '#',
        align:'center',
        scopedSlots: { customRender: 'serial' }
      },
      {
        title: 'Code',
        dataIndex: 'couponCode',
        scopedSlots: { customRender: 'couponCode' }
      },
      {
        title: 'Description',
        dataIndex: 'description',
        scopedSlots: { customRender: 'description' }
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        scopedSlots: { customRender: 'amount' }
      },
      {
        title: 'Status',
        dataIndex: 'couponStatus',
        // customRender: (value) => value == '0' ? 'Not Use' : 'Used'
        scopedSlots: { customRender: 'couponStatus' }
      },
    ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // parameter.pageSize = 100
        parameter.curPage = parameter.pageNo
        const customerCode = this.currentWebSiteType == 'Signet' ? this.record.signetCustomerCode : this.record.superaCustomerCode
        return CustomerCouponApi.getAllCouponByCustomer(customerCode, Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(JSON.parse(res.data))
          })
      },
      selectedRowKeys: [],
      superaSelectedRowKeys: [],
      isModalShow: false,
      convertForm: {
        toCustomerCode: '',
        remark: ''
      },
      toCustomerCodeValid: {
        status: '',
        help: ''
      },
      editData: null,
      statisticalData: null,
      currentWebSiteType: 'Signet'
    }
  },
  computed: {
    rowSelectionConfig () {
      if (this.isMainShow) {
        return null
      }
      let selectedRowKeys
      if (this.currentWebSiteType == 'Signet') {
        selectedRowKeys = this.selectedRowKeys
      } else {
        selectedRowKeys = this.superaSelectedRowKeys
      }
      return {
        selectedRowKeys: selectedRowKeys,
        onChange: this.onSelectChange,
        columnWidth: '32px'
      }
    }
  },
  mounted () {
    this.loadEditData()
  },
  methods: {
    async loadEditData() {
      try {
        const customerCode = this.currentWebSiteType === 'Signet' ? this.record.signetCustomerCode : this.record.superaCustomerCode
        const res = await CustomerApi.getCusCouponDataStatistics(customerCode)
        this.statisticalData = JSON.parse(res.data)
      } catch (e) {
        console.log('error', e)
      }
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    handleWebSiteTypeChange (e) {
      this.currentWebSiteType = e.target.value
      this.loadEditData()
      if (this.$refs.table) {
        this.$refs.table.loadData({ pageNo: 1, pageSize: 100 })
      }
      this.$emit('web-site-type-change', this.currentWebSiteType)
    },
    handleCouponCodeClick (record) {
      this.isModalShow = true
      this.editData = record
      this.convertForm.toCustomerCode = ''
      this.convertForm.remark = ''
      this.toCustomerCodeValid.status = 'success'
      this.toCustomerCodeValid.help = ''
    },
    async handleSave () {
      this.saving = true
      const convertForm = this.copyDataByJSON(this.convertForm)
      convertForm.couponId = this.editData.id
      if (convertForm.toCustomerCode == null || convertForm.toCustomerCode == '') {
        this.toCustomerCodeValid.status = 'error'
        this.toCustomerCodeValid.help = 'Please input customer code!'
        this.saving = false
        return
      } else {
        this.toCustomerCodeValid.status = 'success'
        this.toCustomerCodeValid.help = ''
      }
      try {
        const res = await CustomerApi.changeApplyCoupon(convertForm)
        if (!this.mixinProcessHasBizErrorNotification(res)) {
          this.mixinProcessSuccessNotification('Save successfully!')
          this.isModalShow = false
        }
      } catch (e) {
        this.mixinNotBizErrorResponseNotification(e)
      } finally {
        this.saving = false
      }
    },
    isCouponClickable (record) {
      const basicCondition = record.transferable == '1' && record.couponType !== '4' && record.couponStatus !== '1' && record.cancleStatus !== '1' && record.disabled !== '1'
      if (!basicCondition) return false
      try {
        return !record.expirationDate || (record.expirationDate && moment(record.expirationDate).isSameOrAfter(moment(), 'day'))
      } catch (e) {
        console.error('Date parsing error:', e)
        return false
      }
    },
    onSelectChange (selectedRowKeys) {
      if (this.currentWebSiteType == 'Signet') {
        this.selectedRowKeys = selectedRowKeys
      } else {
        this.superaSelectedRowKeys = selectedRowKeys
      }
    }
  },
  watch: {
    webSiteType(newVal) {
      this.currentWebSiteType = newVal
      this.loadEditData()
      if (this.$refs.table) {
        this.$refs.table.loadData()
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* ::v-deep .ant-table-pagination {
  display: none !important;
} */
::v-deep .ant-table-thead > tr > th {
  white-space: nowrap !important;
}
::v-deep .ant-tag {
  font-weight: 500;
}
.coupon-info-container {
  margin-bottom: 16px;
  background: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  
  .coupon-info-row {
    display: flex;
    flex-wrap: wrap;
  }
  
  .coupon-info-item {
    display: flex;
    align-items: center;
    min-width: 200px;
    
    .info-label {
      font-weight: bold;
      margin-right: 8px;
      white-space: nowrap;
      color: #333;
    }
    
    .info-content {
      word-break: break-word;
    }
  }
}
::v-deep .ant-form-item {
  margin-bottom: 6px;
}
.coupon-statistics {
  margin-bottom: 14px;
  font-size: 14px;
  
  .stat-label {
    font-weight: bold;
    color: #333;
    margin-right: 4px;
    
    &::after {
      content: '';
      margin-right: 8px;
    }
  }
  
  .stat-value {
    margin-right: 16px;
  }
}
</style>